module.exports = __webpack_public_path__ + "img/RECYCLE_BIN.d0ab6848.svg";